import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=bf57755a&"
import script from "./UiCard.vue?vue&type=script&lang=js&"
export * from "./UiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports